import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CourseService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Course');
	}
	
	loadAll() : Observable<ePM.Logic.Course[]> {
		return this.myBaseService.loadAll(this.url);
    }
    loadAllCourseLessons(id: System.Guid): Observable<ePM.Logic.CourseLesson[]> {
        return this.myBaseService.loadAll(this.url + '/Lessons/' + id);
    }
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.Course> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.Course> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.Course>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<ePM.Logic.Course[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search');
	}
}
				